<svg
  (click)="goToStudio()"
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
>
  <title>edit in studio</title>
  <path
    d="M12.4042 7.88947L13.1708 8.65614L5.62083 16.2061H4.85417V15.4395L12.4042 7.88947ZM15.4042 2.8728C15.1958 2.8728 14.9792 2.95614 14.8208 3.11447L13.2958 4.63947L16.4208 7.76447L17.9458 6.23947C18.2708 5.91447 18.2708 5.38947 17.9458 5.06447L15.9958 3.11447C15.8292 2.9478 15.6208 2.8728 15.4042 2.8728ZM12.4042 5.53114L3.1875 14.7478V17.8728H6.3125L15.5292 8.65614L12.4042 5.53114Z"
    fill="black"
    fill-opacity="0.6"
  />
</svg>
